import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

type Card = { title: string; desc: string; to: string };

const CARDS: Card[] = [
  { title: "לוח בקרה", desc: "תמונת מצב — צוות וקבוצות", to: "/paamon/dashboard" },
  { title: "תוכנית פעולה", desc: "יעדים ומשימות שבועיות", to: "/paamon/tasks" },
  { title: "רשימת המתנה", desc: "תלמידים בהמתנה לשיבוץ", to: "/paamon/waiting-list" },
  { title: "אנשי קשר שיווקיים", desc: "המלצות, פרסום ופרטנרים", to: "/paamon/marketing-contacts" },
  { title: "סקריפט שיחות", desc: "טלפונים ומעקב המרה", to: "/paamon/phone-scripts" },
  { title: "משימות עירייה", desc: "מעקב אורית — עיריית תל אביב", to: "/paamon/municipality" },
  { title: "ישב״ץ ראשון", desc: "אג׳נדת ישיבת הפתיחה", to: "/paamon/first-meeting" },
  { title: "פוליפוניה", desc: "תוכנית מוזיקה — מורים, שירים", to: "/paamon/polyphony" },
  { title: "הודעת פתיחה", desc: "הודעת WhatsApp לצוות", to: "/paamon/opening-message" },
  { title: "מדריך למורים", desc: "נהלים, חירום, יומיום", to: "/paamon/teacher-guide" },
  { title: "פלייר שיווקי", desc: "פרסום להורים", to: "/paamon/flyer" },
  { title: "מודעת דרושים", desc: "גיוס מנחים", to: "/paamon/job-posting" },
  { title: "דיווח טיפול", desc: "תבנית דיווח אנונימי", to: "/paamon/treatment-report" },
];

// DEM-40 follow-up (board feedback): /paamon home is the knowledge index.
// The sidebar already labels the page ("פעמון"), so the page-level h1 is
// gone — opens straight into the link card grid. Background blue via
// Layout's SKY_BLUE_ROUTES.
export function PaamonHomePage() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {CARDS.map((c) => (
        <Link
          key={c.to}
          to={c.to}
          className="group rounded-2xl bg-white px-5 py-4 hover:bg-stone-100/70 transition-colors border border-stone-200/60"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="text-sm font-semibold text-stone-900">{c.title}</div>
              <div className="text-xs text-stone-500 mt-1 leading-relaxed">{c.desc}</div>
            </div>
            <ArrowLeft className="h-4 w-4 text-stone-400 group-hover:text-stone-900 transition-colors shrink-0 mt-0.5" />
          </div>
        </Link>
      ))}
    </div>
  );
}
